<template>
  <div class="inline">
    <span class="text-chplus-regular" :class="{ 'text-white': highlight }">{{
      averageAge
    }}</span>
  </div>
</template>

<script>
export default {
  name: "AverageAge",
  props: {
    people: {
      type: Array,
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    averageAge() {
      let validCount = 0;
      let age = this.people.reduce((age, person) => {
        if (!person || !person.birthYear) {
          return age;
        }
        validCount++;
        let currentYear = new Date().getFullYear();
        return age + currentYear - person.birthYear;
      }, 0);
      if (validCount > 0) {
        return (age / validCount).toFixed(0);
      } else {
        return "-";
      }
    }
  }
};
</script>
